var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 32.692"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m.478 15.179 14.7-14.7a1.651 1.651 0 0 1 2.337 2.332L3.981 16.345l13.534 13.53a1.651 1.651 0 1 1-2.337 2.334l-14.7-14.7a1.665 1.665 0 0 1 0-2.33"
  })));
};
export default SvgArrowLeft;